import * as z from "zod";
import { REQUIRED_MESSAGE } from "components/form/utils";

export const screenshotsSchema = z.object({
    screenshots: z.array(z.any()).min(1, REQUIRED_MESSAGE),
});

